<script>
  import session from '../lib/session';
  import Selector from '../lib/components/Selector.svelte';
  import APIClient from '../state-charts/api-client';
  import { show_message } from '../lib/flash.ts';
  import { t9n } from '../lib/translate.js';
  import { TS } from '../config/translation-keys.js';
  import { download_file } from '../lib/utils.js';
  import InputWithDate from '../lib/components/InputWithDate.svelte';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import DatePicker from '../lib/components/DatePicker.svelte';

  // component options  ------------------------------------------------------ //

  export let route_name;

  // translated strings ------------------------------------------------------ //

  let reports = t9n(TS.WORKER_REPORTS_TITLE);
  let report_label = t9n(TS.WORKER_REPORTS_REPORT_INPUT_TITLE);
  let creation_date_label = t9n(TS.WORKER_REPORTS_CREATION_DATE_LABEL);
  let completion_date_label = t9n(TS.WORKER_REPORTS_COMPLETION_DATE_LABEL);
  let select_label = t9n(TS.WORKER_REPORTS_SELECT_SERVICE_LABEL);
  let period_label = t9n(TS.WORKER_REPORTS_PERIOD_LABEL);
  let from_date_label = t9n(TS.WORKER_REPORTS_PERIOD_FROM_LABEL);
  let to_date_label = t9n(TS.WORKER_REPORTS_PERIOD_TO_LABEL);
  let button_in_progress_text = t9n(TS.WORKER_REPORTS_IN_PROGRESS_TEXT);
  let button_text = t9n(TS.WORKER_REPORTS_DOWNLOAD_LABEL);
  let worker_type_label = t9n(TS.WORKER_REPORTS_WORKER_TYPE_SELECTOR_LABEL);
  let completed_tasks_label = t9n(TS.WORKER_REPORTS_COMPLETED_TASKS)
  let payment_report_label = t9n(TS.WORKER_REPORTS_PAYMENT_REPORT)


  // internal variables ------------------------------------------------------ //

  let worker_type_selector;
  let worker_selector_items = [];
  let report_items = []
  let date_from = new Date().toISOString().substr(0, 10);
  let date_to = new Date().toISOString().substr(0, 10);
  let date_type = 'created_at';
  let loading = false;
  let file_name = 'report.pdf';
  let merchant = $session.merchant.service.selection_name;
  let worker_type = $session.user.worker_type;
  let report_type = payment_report_label;

  // utility functions -------------------------------------------------------- //

  const worker_type_id = translated_name => {
    if (worker_type === $session.user.worker_type) {
      return worker_type;
    }
    return $session.api_config.worker_types.find(
      wt => t9n(wt) === translated_name,
    );
  };

  const submit_form = async () => {
    loading = true;

    let data = {
      worker_type: worker_type,
      date_from,
      date_to,
    };

    if (!!date_from) data.date_from = date_from;
    if (!!date_to) data.date_to = date_to;

    if (report_type === completed_tasks_label) {
      try {
        const response = await APIClient.get_completed_task_report_url(data);
        download_file(response.url, 'worker_task_report.pdf');
      } catch (error) {
        show_message(error, 'error');
      }
    } else {
      try {
        const response = await APIClient.get_worker_report_url(data);
        download_file(response.url, 'worker_report.pdf');
      } catch (error) {
        show_message(error, 'error');
      }
    }

    loading = false;
  };

  const init_selector_items = () => {
    document.querySelector('.mdc-top-app-bar--fixed-adjust').scrollIntoView({ behavior: 'smooth' });
    worker_selector_items = $session.api_config.worker_types.map((wt, idx) => ({
      val: wt,
      name: t9n(wt),
    }));

    report_items = [
      {
        name: payment_report_label,
        val: payment_report_label,
        show: true
      },
      {
        name: completed_tasks_label,
        val: completed_tasks_label,
        show: true
      },
    ]
  };

  const init_worker_type = () => {
    worker_type = $session.user.worker_type;
  };

  // reactive functions -------------------------------------------------------- //

  $: if (!!$session.api_config) {
    init_selector_items();
    init_worker_type();
  }
</script>

  <form class='reports-form' id='reports_form'>

    <div style='text-align: center;'>
      <h1 style='margin-bottom: 35px' class='mdc-typography--headline5'>
        {reports}
      </h1>
    </div>

    <div class='native-sel-width'>
      <Selector
        id="reports"
        label={report_label}
        bind:items={report_items}
        bind:value={report_type} />
    </div>

    <div
      class='native-sel-width'
      style='margin-top: 15px; margin-bottom: 15px;'>
      <Selector
        id='worker_type_selector'
        label={worker_type_label}
        bind:items={worker_selector_items}
        bind:value={worker_type} />
    </div>

    <div style='margin-top: 1px; display: flex; flex-wrap: wrap'>
      <div
        style='position: relative; margin-bottom: 16px; margin-right: 10px'>

        <DatePicker
          id='period-from'
          label={`${period_label} ${from_date_label.toLowerCase()}`}
          bind:value={date_from}
          min='2014-01-01'
          is_end_date={true}
          max={date_to} />
<!--        <InputWithDate-->
<!--          id='period-from'-->
<!--          label={`${period_label} ${from_date_label.toLowerCase()}`}-->
<!--          bind:value={date_from}-->
<!--          name='date_from'-->
<!--          min='2014-01-01'-->
<!--          max={date_from} />-->
      </div>
      <div style='position: relative'>
        <DatePicker
          id='period-to'
          label={`${period_label} ${to_date_label.toLowerCase()}`}
          bind:value={date_to}
          min={date_from}
          is_end_date={true}
          max={new Date().toISOString().substr(0, 10)} />
<!--        <InputWithDate-->
<!--          id='period-to'-->
<!--          label={`${period_label} ${to_date_label.toLowerCase()}`}-->
<!--          bind:value={date_to}-->
<!--          name='date_to'-->
<!--          min={date_from}-->
<!--          max={new Date().toISOString().substr(0, 10)} />-->
      </div>
    </div>

    <div style='margin-top: 100px; text-align: center'>
      <button
        data-cy='report'
        class='mdc-button mdc-button--raised'
        on:click|preventDefault={async () => { await submit_form() } }>
        {#if loading}
          {button_in_progress_text}
          <div class='loader' />
        {:else}{button_text}{/if}
      </button>
    </div>

  </form>

<style>
    p {
        margin: 0;
        padding-top: 20px;
        padding-left: 15px;
    }

    select {
        display: block;
        font-size: 1em;
        font-family: 'Open Sans', sans-serif;
        font-weight: 300;
        line-height: 1.5;
        padding: 0.4em 3.5em 0.3em 0.8em;
        /* width: 10em; */
        max-width: 100%;
        box-sizing: border-box;
        margin: 0;
        border-radius: 0.3em;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background-color: white;
        background-image: linear-gradient(45deg, transparent 50%, grey 50%),
        linear-gradient(135deg, grey 50%, transparent 50%),
        linear-gradient(to right, grey, grey);
        background-position: calc(100% - 20px) 1em, calc(100% - 15px) 1em,
        calc(100% - 2.5em) 0.3em;
        background-size: 5px 5px, 5px 5px, 1px 1.5em;
        background-repeat: no-repeat;
    }

    select::-ms-expand {
        display: none;
    }

    select:hover {
        border-color: #888;
    }

    select:focus {
        outline: 0;
    }

    select option {
        font-weight: normal;
    }

    .reports-form {
        padding: 0px 40px 25px 40px;
    }

    .mdc-style-input {
        border: 1px solid #aaa;
        padding: 0 0.8em;
        border-radius: 0.3em;
        color: #767676;
        font-weight: 300;
        line-height: 3.4;
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
    }

    .mdc-floating-label2 {
        font-family: Roboto, sans-serif;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-size: 0.81rem;
        color: #767676;
        line-height: 1.75rem;
        font-weight: 400;
        letter-spacing: 0.009375em;
        position: absolute;
        left: 13px;
        margin-top: -14px;
        /*margin-left: 13px;*/
        background-color: white;
    }

    .loader {
        display: inline-block;
        font-size: 10px;
        margin: 0 1em -2px;
        text-indent: -9999em;
        width: 1.5em;
        height: 1.5em;
        border-radius: 50%;
        background: #ffffff;
        background: -moz-linear-gradient(
                left,
                #ffffff 10%,
                rgba(255, 255, 255, 0) 42%
        );
        background: -webkit-linear-gradient(
                left,
                #ffffff 10%,
                rgba(255, 255, 255, 0) 42%
        );
        background: -o-linear-gradient(
                left,
                #ffffff 10%,
                rgba(255, 255, 255, 0) 42%
        );
        background: -ms-linear-gradient(
                left,
                #ffffff 10%,
                rgba(255, 255, 255, 0) 42%
        );
        background: linear-gradient(
                to right,
                #ffffff 10%,
                rgba(255, 255, 255, 0) 42%
        );
        position: relative;
        -webkit-animation: load3 1.4s infinite linear;
        animation: load3 1.4s infinite linear;
        -webkit-transform: translateZ(0);
        -ms-transform: translateZ(0);
        transform: translateZ(0);
    }

    .loader:before {
        width: 50%;
        height: 50%;
        background: #ffffff;
        border-radius: 100% 0 0 0;
        position: absolute;
        top: 0;
        left: 0;
        content: '';
    }

    .loader:after {
        background: #007bff;
        width: 75%;
        height: 75%;
        border-radius: 50%;
        content: '';
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    @-webkit-keyframes load3 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes load3 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    /* Desktop Mode
      *******************************************************/
    @media (min-width: 1025px) {
        .native-sel-width {
            width: 100% !important;
        }

        .wrapper {
            width: 600px;
            margin: 0 auto;
            margin-bottom: 50px;
            height: fit-content;
        }
    }

    /* Tablet Mode
      *******************************************************/
    @media (min-width: 769px) and (max-width: 1024px) {
        .native-sel-width {
            width: 100% !important;
        }

        .wrapper {
            width: 90%;
            margin: 0 auto;
            margin-bottom: 50px;
            height: fit-content;
        }
    }

    /* Mobile Mode
      *******************************************************/
    @media (min-width: 0) and (max-width: 768px) {
        .native-sel-width {
            width: 100% !important;
        }

        .wrapper {
            /*width: 100%;*/
            margin: 0 auto;
            margin-left: 50px;
            margin-bottom: 50px;
            height: fit-content;
        }

        /* todo: Something hijacks this input's look on mobile, so these are hacks that fixes it on Galaxy 4 */
        .mdc-style-input {
            border: 1px solid #aaa;
            padding: 0 0.8em;
            border-radius: 0.3em;
            color: #767676;
            font-weight: 300;
            line-height: 3.4;
            font-family: 'Open Sans', sans-serif;
            font-size: 16px;
            background: white;
            height: 54px;
        }

        .mdc-floating-label2 {
            margin-top: -69px;
        }

        #for-mobile-input {
            margin-top: 11px;
        }
    }
</style>
